import { Map } from "../types/Map";

export const LEAFLET_BOUND_SIZE = 138;
export const LEAFLET_MAP_SIZE = 2 * LEAFLET_BOUND_SIZE;

export default function getBoundsFromMap(map: Map | null): L.LatLngBoundsExpression {
    if (!map) return [[0, 0], [0, 0]];

    if (map.specialBounds) {
        return map.specialBounds;
    } else {
        return [[-LEAFLET_BOUND_SIZE, -LEAFLET_BOUND_SIZE], [LEAFLET_BOUND_SIZE, LEAFLET_BOUND_SIZE]];
    }
}